// look for [data-alertbanner].
document.addEventListener('DOMContentLoaded', bindAlertBanners);

export function bindAlertBanners() {
    document.querySelectorAll<HTMLElement>('[data-alertbanner]').forEach(alert => {
        setupAlertCloseEvent(alert);
    });
}

function setupAlertCloseEvent(alert: HTMLElement) {
    const closeButton = alert.querySelector<HTMLButtonElement>(`[data-target=${alert.id}]`);
    if (!closeButton) {
        return;
    }
    closeButton.addEventListener('click', () => closeAlertBanner(alert.id));
}

function closeAlertBanner(id: string) {
    const dismissedAlerts = JSON.parse(sessionStorage.getItem('dismissedAlerts') || '{}');
    dismissedAlerts[id] = new Date();
    sessionStorage.setItem('dismissedAlerts', JSON.stringify(dismissedAlerts));
}
